import React from 'react';
import Stack from '@mui/material/Stack';

import { Table, TableOptions } from '../../common/types/general';
import { Transfer } from '../../common/types/transfer';
import formatter from '../../common/helpers/formatter';
import coreDataForm from '../detail/fhfForm/coreDataForm';
import { priorityMapping } from '../../common/constants';
import sort from '../../common/helpers/sort';

const reactAppVersion = process.env.REACT_APP_VERSION;

const fhfTable: Table<Transfer>[] = [
  {
    headline: 'Kategorie',
    type: 'text',
    value: (transfer) => {
      const fields = formatter.getFieldSelectOptions<Transfer>('category', coreDataForm([]).fields);
      return formatter.getOptionLabel(fields, transfer.category);
    },
  },
  { headline: 'Von', type: 'text', value: (transfer) => transfer.from },
  { headline: 'An', type: 'text', sortable: 'to', value: (transfer) => transfer.to },
  { headline: 'Thema', type: 'text', value: (transfer) => transfer.topic },
  {
    headline: 'Datum',
    type: 'text',
    sortable: 'appointmentDate',
    value: (transfer) => formatter.formatGermanDate(transfer.appointmentDate),
  },
  {
    headline: 'Status',
    type: 'boolean',
    value: (transfer) => transfer.state,
  },
  {
    headline: 'Priorität',
    type: 'text',
    sortable: 'priority',
    value: (transfer) => {
      const fields = formatter.getFieldSelectOptions<Transfer>('priority', coreDataForm([]).fields);
      const label = formatter.getOptionLabel(fields, transfer.priority);
      const { icon } = transfer.priority
        ? priorityMapping[transfer.priority as keyof typeof priorityMapping]
        : { icon: undefined };

      return (
        <Stack direction='row' alignItems='center' gap={1}>
          {icon}
          {label}
        </Stack>
      );
    },
  },
  { headline: '', type: 'delete', value: () => '' },
];

const getTransferTableOptions = (): TableOptions<Transfer> => {
  if (reactAppVersion === 'fhf') {
    return {
      table: fhfTable,
      sort: (itemA, itemB, sortBy) => {
        if (sortBy != null && sortBy.sortable === 'appointmentDate') {
          return sort.sortByDate(itemA.appointmentDate, itemB.appointmentDate, sortBy.order);
        }
        if (sortBy != null && sortBy.sortable === 'to') {
          return sort.sortByString(itemA.to, itemB.to, sortBy.order);
        }
        if (sortBy != null && sortBy.sortable === 'priority') {
          return sort.sortByPriority(itemA.priority, itemB.priority, sortBy.order);
        }
        return -1;
      },
      filter: (searchValue, item) =>
        (item.category || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.topic || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.to || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.from || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  return { table: [], sort: () => 1, filter: () => true };
};

export default getTransferTableOptions;
